import { ZTIRegion } from '@byted/tiktok-zti-types';
import { Collector, IInitParam } from '@dp/byted-tea-sdk-oversea';

const __DEV__ = process.env.NODE_ENV === 'development';

export enum EventNameMap {
  // 接口回包上报
  logWebBdTicketGuardConsumerResponse = 'web_tt_ticket_guard_consumer_response',
  // 浏览支持能力上报
  logWebBdTicketGuardEnv = 'web_tt_ticket_guard_env',
  // local丢失上报
  logWebBdTicketGuardLocalMiss = 'web_tt_ticket_guard_local_miss',
  // 退出页面的时候上报iframe状态
  logWebBdTicketGuardIframeStatusBeforeUnLoad = 'web_tt_ticket_guard_iframe_status_before_unload',
  // 加签获取数据的时候上报iframe状态
  logWebBdTicketGuardIframeStatus = 'web_tt_ticket_guard_iframe_status',
  // 上报失败情况
  logWebBdTicketGuardConsumerResponseError = 'web_tt_ticket_guard_consumer_response_error',

  logFullPath = 'tt_ticket_guard_web_full_path',
  logPerformance = 'tt_ticket_guard_web_performance',
  logGetStorage = 'tt_ticket_guard_web_get_storage',
  logSetStorage = 'tt_ticket_guard_web_set_storage',
  logGenerateKeys = 'tt_ticket_guard_web_gerate_keys',
  logGenerateCSR = 'tt_ticket_guard_web_generate_csr',
  logSign = 'tt_ticket_guard_web_sign',
  logStorageFail = 'tt_ticket_guard_storage_fail',
  logJsrsasignPerformance = 'tt_ticket_guard_jsrsasign',
  logFetchServerDataFromCookie = 'tt_fetch_server_data',
  logFetchJSVersion = 'tt_ticket_guard_js_version'
}

export type TeaInitConfig = {
  appId: number;
  config?: any;
  region?: ZTIRegion;
};

const commonParams = {
  params_for_special: 'tiktok_account_login'
};

const getChannelParams: (
  region: ZTIRegion
) => Pick<IInitParam, 'channel' | 'channel_type' | 'channel_domain'> = (region) => {
  if (region === 'eu') {
    return {
      channel: 'ie2',
      channel_type: 'ttp',
      channel_domain: 'https://mcs16-normal-no1a.tiktokw.eu'
    };
  }
  if (region === 'oci') {
    return {
      channel: 'va',
      channel_type: 'ttp'
    };
  }
  return {
    channel: region,
    channel_type: 'tcpy'
  };
};

// tea实例化 - 单例
class ITea {
  static _instance: ITea | null;

  private zeroTrustTea = new Collector('zeroTrustTea');

  private constructor({ appId, config = {}, region = 'va' }: TeaInitConfig) {
    this.zeroTrustTea.init({
      app_id: 1992,
      ...getChannelParams(region),
      log: Boolean(__DEV__),
      disable_auto_pv: true,
      disable_webid: true
    });
    this.setConfig(config);
    this.zeroTrustTea.start();
    (window as any).$ZERO_TRUST_MONITOR = this;
  }

  static initTea({ appId, config = {}, region }: TeaInitConfig): ITea {
    if (!this._instance) {
      this._instance = new ITea({ appId, config, region });
    }
    return this._instance;
  }

  static getTea() {
    if ((window as any).$ZERO_TRUST_MONITOR) {
      return (window as any).$ZERO_TRUST_MONITOR;
    }
    return this._instance;
  }

  setEvtParams(evtParams: { [key: string]: any }) {
    this.zeroTrustTea.config({
      evtParams
    });
  }

  setConfig(config = {}) {
    this.zeroTrustTea.config({
      _staging_flag: __DEV__ ? 1 : 0,
      ...config
    });
  }

  sendLog(eventName: string, params?: any) {
    if (eventName) {
      this.zeroTrustTea.event(eventName, params);
    }
  }

  sendBecon(eventName: string, params?: any) {
    if (eventName) {
      this.zeroTrustTea.beconEvent(eventName, params);
    }
  }
}

export const initTea = (opt: { appId?: number; webId?: string; config?: any; region?: ZTIRegion }) => {
  const { appId = 1992, webId = '', config = {}, region } = opt;
  ITea.initTea({
    appId: appId || 1992,
    config: {
      user_unique_id: webId,
      device_id: webId,
      user_id: webId,
      ...config
    },
    region
  });
};

export const setEvtParams = (parmas: any = {}) => {
  ITea.getTea()?.setEvtParams(parmas);
};

export const sendLog = <T extends Record<string, any>>(eventName: string, parmas?: T) =>
  ITea.getTea()?.sendLog(eventName, {
    ...commonParams,
    ...(parmas || {})
  });

export const sendBecon = (eventName: string, parmas?: Record<string, any>) =>
  ITea.getTea()?.sendBecon(eventName, {
    ...commonParams,
    ...(parmas || {})
  });
